import { useEffect, useState } from 'react';
import { dsClass } from '../../common/constants/dsClasses.js';
import { fetchBillingAccounts } from '../../common/fetch.js';
import { notMandatoryMsg, t } from '../../common/i18n/index.js';
import { BillingAccount } from '../../common/react-hook-form/fields/BillingAccount.js';
import { CostCenter } from '../../common/react-hook-form/fields/CostCenter.js';
import { Reference } from '../../common/react-hook-form/fields/Reference.js';
import { SourceSystem } from '../../generated/api/sourceSystem.js';
import { Loading } from '../Loading/index.js';
import type { BillingAccountSearchResponse } from '../../generated/api/models.js';

interface CustomerOrderBillingInfoParams {
  isInternalCustomer: boolean;
  selectedBillingAccounts?: string[];
}

export const CustomerOrderBillingInfo = ({
  isInternalCustomer,
  selectedBillingAccounts,
}: CustomerOrderBillingInfoParams) => {
  const [billingAccounts, setBillingAccounts] = useState<BillingAccountSearchResponse[]>();

  useEffect(() => {
    fetchBillingAccounts({ useSearchService: true, sourceSystem: SourceSystem.SFDC }).then(bs => {
      setBillingAccounts(bs.searchResults || []);
    });
  }, []);

  const billingAccountsToDisplay =
    selectedBillingAccounts?.length && billingAccounts
      ? billingAccounts.filter(
          ba => ba.result.billingAccountId && selectedBillingAccounts.includes(ba.result.billingAccountId)
        )
      : (billingAccounts ?? []);

  return (
    <div className="of-customer-order-details__business-account">
      <h3 className={dsClass.MARGIN_BOTTOM_2}>{t.W1ZW('Billing information for the products')}</h3>
      <div className="of-customer-order-details__business-account__grid">
        <div className="of-customer-order-details__business-account__field">
          <CostCenter
            label={`${t.L2OG('Cost Center')}${!isInternalCustomer ? ' ' + t.NFRH(notMandatoryMsg) : ''}`}
            maxLength={40}
            required={isInternalCustomer}
          />
        </div>
        <div className="of-customer-order-details__business-account__field">
          <Reference
            label={`${t.WGGQ('e.g. employee number')}${!isInternalCustomer ? ' ' + t.NFRH(notMandatoryMsg) : ''}`}
            required={false}
            maxLength={80}
            hint={undefined}
          />
        </div>
        <div className="of-customer-order-details__business-account__select">
          {!billingAccounts ? (
            <Loading />
          ) : (
            <BillingAccount
              billingAccounts={billingAccountsToDisplay}
              name="billingAccountId"
              enableAddNewBa={false}
              required={false}
            />
          )}
        </div>
      </div>
    </div>
  );
};
